import React, { createRef } from 'react'
import { ifStringEmpty, handleIE } from '../../../actions/static'
import { SendIcon } from '../../../icons/Icons'
import classNames from 'classnames'
import { keyType } from '../../../constants/string'
import classes from './styles.module.scss'

class ChatInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      text: '',
    },
    this.textInput = createRef()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { autofilledText, isTextDisabled } = this.props
    if (prevProps.autofilledText !== autofilledText && autofilledText) {
      this.setState({
        text: autofilledText,
      })
    }
  }

  sendText = () => {
    const { text } = this.state
    if (!ifStringEmpty(text)) {
      const message = {
        from: {
          id: this.props.chatId,
          name: this.props.startData.name || 'Widget user',
          email: this.props.startData.email || '',
        },
        type: 'text',
        isRtl: this.props.isRtl,
        text,
      }
      this.setState(
        {
          text: '',
        },
        () => {
          this.props.postMessage(message)
        },
      )
    }
  }

  handleChange(value) {
    this.setState({
      text: value,
    })
  }

  keyDownListener = (e) => {
    const currentKey = e.key.toLowerCase()
    if (currentKey === keyType.ENTER) {
      e.preventDefault()
      this.sendText()
    }
  }

  render() {
    const {
      isTextDisabled,
      settings,
      isRtl,
    } = this.props
    const { text } = this.state
    const isIE = handleIE()
    const direction = isRtl ? 'rtl' : 'ltr'
    return (
      <section
        className={classNames(classes.wrapInput, isTextDisabled ? classes.hide : null)}>
        <input
          placeholder={settings?.inputPlaceholder}
          className={classes.input}
          id="messaging-user-input"
          style={{ direction, visibility: isTextDisabled ? 'hidden' : 'visible' }}
          type="text"
          ref={this.textInput}
          value={text}
          data-test='user-input'
          onKeyDown={this.keyDownListener}
          dir={direction}
          onChange={e => this.handleChange(e.target.value)}
          autoComplete="off"
          tabIndex={isTextDisabled ? -1 : 0}
        />
        <button
          style={{ visibility: isTextDisabled ? 'hidden' : 'visible' }}
          data-test='user-input-send-button'
          tabIndex={isTextDisabled ? -1 : 0}
          onClick={this.sendText}
          onKeyDown={this.keyDownListener}
          className={classes.svgHolder}
        >
          <SendIcon />
        </button>
      </section>
    )
  }
}

export default ChatInput
